module.exports = __webpack_public_path__ + "17e824c3.svg";